import { ModuleWithProviders } from '@angular/core';
import { ReplaceableComponentDirective } from './dynamic-components/components/replaceable-component.directive';
import { FeatureProvidersRegistry, FeatureRegistry, RouterLinkResolverService } from '@core/shared/feature';
import { VirtualPropertiesRegistry } from '@core/shared/virtual-properties';
import { BASE_FEATURES_PROVIDER, FrontendFeatureRegistry } from './feature-registry';
import { FEATURE_PROVIDERS, FrontendFeatureProvidersRegistry } from './providers/frontend-feature-providers.registry';
import { VirtualPropertiesFrontendRegistry } from './virtual-properties-frontend.registry';
import { RouterLinkRedirectsService } from './router-link-redirects';
import { FeatureWidgetsRegistry } from './widgets';
import * as i0 from "@angular/core";
import * as i1 from "./widgets";
import * as i2 from "@core/shared/virtual-properties";
import * as i3 from "./providers/frontend-feature-providers.registry";
import * as i4 from "./router-link-redirects";
const publicDeclarations = [ReplaceableComponentDirective];
export let CoreFeatureModule = /*#__PURE__*/(() => {
  class CoreFeatureModule {
    static forRoot(baseFeaturesCtors, providers = []) {
      return {
        ngModule: CoreFeatureModule,
        providers: [VirtualPropertiesFrontendRegistry, {
          provide: VirtualPropertiesRegistry,
          useExisting: VirtualPropertiesFrontendRegistry
        }, {
          provide: BASE_FEATURES_PROVIDER,
          useValue: baseFeaturesCtors
        }, {
          provide: FEATURE_PROVIDERS,
          useValue: providers
        }, {
          provide: RouterLinkResolverService,
          useFactory: registry => new RouterLinkResolverService(registry),
          deps: [FeatureRegistry]
        }]
      };
    }
    constructor(w, x, y, z) {}
    static {
      this.ɵfac = function CoreFeatureModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CoreFeatureModule)(i0.ɵɵinject(i1.FeatureWidgetsRegistry), i0.ɵɵinject(i2.VirtualPropertiesRegistry), i0.ɵɵinject(i3.FrontendFeatureProvidersRegistry), i0.ɵɵinject(i4.RouterLinkRedirectsService));
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: CoreFeatureModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [{
          provide: FeatureRegistry,
          useExisting: FrontendFeatureRegistry
        }, {
          provide: FeatureProvidersRegistry,
          useExisting: FrontendFeatureProvidersRegistry
        }]
      });
    }
  }
  return CoreFeatureModule;
})();